// frontend/admin-portal/src/services/brandService.js
import api from './axiosConfig';

export const brandService = {
    list: async (params = {}) => {
        const { data } = await api.get('/brands', { params });
        return data.data.brands;
    },
    get: async (idOrSlug) => {
        const { data } = await api.get(`/brands/${idOrSlug}`);
        return data.data.brand;
    },
    create: async (payload) => {
        const { data } = await api.post('/brands', payload);
        return data.data.brand;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/brands/${id}`, payload);
        return data.data.brand;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/brands/${id}`);
        return data;
    },
};